import React, { useContext } from "react";
import VideoConsultaIcon from "../../../assets/images/generico/VideoConsultaIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import { wsLlamadaAtendida } from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import { amOrPm } from "../../../../global/utils/amOrPm";
import camelize from "../../../../global/utils/camelize";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./VideoLlamada.css";

const VideoLlamada = ({
  titulo,
  dissmiss,
  especialidad,
  medico,
  fechaTurno,
  horaProgramada,
  estado,
  idturno,
  roomId,
  roomIdOpe,
  fechaCambioEstado,
}) => {
  const { segundoModalDispatch, turnosPacienteDispatch } =
    useContext(PortalContext);

  const urlVideoconsulta = "https://videollamada.dim.com.ar/video.html?create=";

  let fechaCard = new Date(fechaCambioEstado);

  const cerrarModal = () => {
    hideSegundoModal()(segundoModalDispatch);
  };

  const showModalSalirEspera = () => {
    showSegundoModal(
      "Turnos/VideoLlamada/SalirDeEspera",
      {
        titulo: "Salir de la Fila",
        idturno: idturno,
        dissmiss: cerrarModal,
      },
      {},
      "centro",
      true
    )(segundoModalDispatch);
  };

  const atenderLlamadaRecepcionista = () => {
    window.open(`${urlVideoconsulta}${roomIdOpe}`);
  };
  const atenderLlamadaMedico = () => {
    wsLlamadaAtendida(idturno)(turnosPacienteDispatch);
    window.open(`${urlVideoconsulta}${roomId}`);
  };

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-videoLlamada-bodyContainer">
        <div className="ptur-videoLlamada-modalBody">
          <div
            className={
              estado === "E"
                ? "ptur-videoLlamada-containerLlamada"
                : "ptur-videoLlamada-container"
            }
          >
            <div className="ptur-videoLlamada-btnTexto">
              <div className="ptur-videoLlamada-headerCard">
                <TurnoVideoConsultaIcon />
                <p className="rb18m c-white">{especialidad}</p>
              </div>
              <div className="ptur-modalVideoLlamada-body-datos">
                <span className="rb18b">
                  {getDiaStrTurno(fechaTurno)}{" "}
                  <span className="rb18l">
                    {getDiaStrTurno(fechaTurno, true)}
                  </span>
                </span>
                <span className="ptur-modalVideoLlamada-horario rb18b">
                  Horario: <span className="rb18l">{horaProgramada}</span>
                </span>
                <div className="ptur-modalVideoLlamada-lista">
                  <ul>
                    {medico && (
                      <li>
                        Especialista:{" "}
                        <span className="rb16b">{camelize(medico)}</span>
                      </li>
                    )}
                  </ul>
                </div>
                <div>
                  <span className="rb16b"> Consulta:</span>
                  <span> Video Consulta</span>
                </div>
                {estado === "E" ? (
                  <div className="ptur-modalVideoLlamada-btnTxt">
                    <button
                      className={"ptur-modalVideoLlamada-vcBtnActive"}
                      onClick={atenderLlamadaMedico}
                    >
                      <div className={"ptur-modalVideoLlamada-iconoLlamada"}>
                        <VideoConsultaIcon color={"var(--color-white)"} />
                        <span className="ptur-modalVideoLlamada-vcText rb16m">
                          Atender llamada del profesional
                        </span>
                      </div>
                    </button>
                    <span className="ptur-modalVideoLlamada-vcTextInfo rb14m">
                      El profesional lo esta llamando para realizar la Video
                      Consulta. Por favor, atienda presionando el botón verde.
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {estado === "A" ? (
                  <div className="ptur-modalVideoLlamada-btnTxt">
                    <button
                      className={"ptur-modalVideoLlamada-vcBtnActive"}
                      onClick={atenderLlamadaMedico}
                    >
                      <div className={"ptur-modalVideoLlamada-iconoLlamada"}>
                        <VideoConsultaIcon color={"var(--color-white)"} />
                        <span className="ptur-modalVideoLlamada-vcText rb16m">
                          Volver a la videollamada
                        </span>
                      </div>
                    </button>
                    <span className="ptur-modalVideoLlamada-vcTextInfo rb14m">
                      El profesional lo esta llamando para realizar la Video
                      Consulta. Por favor, atienda presionando el botón verde.
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {estado === "P" || estado === "D" || estado === "H" ? (
                  <div className="ptur-modalVideoLlamada-btnTxt">
                    <button
                      className={"ptur-modalVideoLlamada-vcBtnActive"}
                      onClick={atenderLlamadaRecepcionista}
                    >
                      <div className={"ptur-modalVideoLlamada-iconoLlamada"}>
                        <VideoConsultaIcon color={"var(--color-white)"} />
                        <span className="ptur-modalVideoLlamada-vcText rb16m">
                          Atender llamada del recepcionista
                        </span>
                      </div>
                    </button>
                    <span className="ptur-modalVideoLlamada-vcTextInfo rb14m">
                      El recepcionista lo está llamando para comprobar que el
                      sonido y video funcionen correctamente. Por favor, atienda
                      presionando el botón verde
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {estado === "V" ? (
                  <div className="ptur-modalVideoLlamada-btnTxt">
                    <button className="ptur-modalVideoLlamada-vcBtnAguardando">
                      <div className="ptur-modalVideoLlamada-iconoLlamadaAguardando">
                        <span className="ptur-modalVideoLlamada-vcText rb16m">
                          Aguardando en fila de espera virtual
                        </span>
                      </div>
                    </button>
                    <span className="ptur-modalVideoLlamada-vcTextInfo rb14m">
                      Le pedimos que por favor aguarde un momento para que
                      nuestros opeardores puedan realizar su recepción online.
                      Desde:{" "}
                      {fechaCard.getDate() +
                        "/" +
                        (fechaCard.getMonth() + 1) +
                        "/" +
                        fechaCard.getFullYear()}{" "}
                      {fechaCard.getHours() +
                        ":" +
                        (fechaCard.getMinutes() < 10
                          ? "0" + fechaCard.getMinutes()
                          : fechaCard.getMinutes())}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {estado === "V" ? (
          <div className="ptur-modalideoLlamada-salir">
            <button
              className="ptur-videoLlamada-btnCerrar bgc-white c-latex30 rb16m"
              onClick={dissmiss}
            >
              Cerrar
            </button>
            <button
              className="ptur-videoLlamada-btnSalirDeFila bgc-primary c-white rb16m"
              onClick={showModalSalirEspera}
            >
              Salir de la Espera
            </button>
          </div>
        ) : (
          <div className="ptur-modalideoLlamada-salir">
            <button
              className="ptur-videoLlamada-btnCerrar bgc-white c-latex30 rb16m"
              onClick={dissmiss}
            >
              No Atender La Llamada
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default VideoLlamada;
